(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-gallery-controlbox]').forEach(function (box) {
      var mediaGallery = box.closest('media-gallery');
      var viewer = mediaGallery ? mediaGallery.querySelector('slider-component[id^="GalleryViewer-"]') : null;
      if (!viewer) return;
      var list = viewer.querySelector('ul.product__media-list');
      if (!list) return;
      var slides = Array.prototype.slice.call(list.querySelectorAll('li.product__media-item'));
      if (slides.length < 2) return;

      var slideIds = slides.map(function (s) { return s.dataset.mediaId; });

      var segments = Array.prototype.slice.call(box.querySelectorAll('.product-media-gallery__segment'));
      var prevBtn = box.querySelector('.product-media-gallery__ctrl-arrow--prev');
      var nextBtn = box.querySelector('.product-media-gallery__ctrl-arrow--next');
      var pauseBtn = box.querySelector('[data-pause-btn]');
      var dwell = parseInt(box.dataset.speed, 10) || 8000;
      var current = 0;
      var autoplayTimer = null;
      var isPaused = false;
      var segmentStart = 0;
      var segmentDuration = 0;
      var pausedAt = 0;
      var suppressSync = false;

      var activeInit = -1;
      slides.forEach(function (s, i) {
        if (activeInit === -1 && s.classList.contains('is-active')) activeInit = i;
      });
      if (activeInit > -1) current = activeInit;

      function updateSegments() {
        segmentStart = Date.now();
        segmentDuration = dwell;
        segments.forEach(function (seg, i) {
          var fill = seg.querySelector('.product-media-gallery__segment-fill');
          seg.classList.remove('is-active');
          if (!fill) return;
          fill.classList.remove('is-animating');
          fill.style.animationDuration = '';
          if (i < current) {
            seg.classList.add('is-complete');
            fill.style.width = '100%';
          } else if (i === current) {
            seg.classList.remove('is-complete');
            fill.style.width = '0%';
            void fill.offsetWidth;
            fill.style.animationDuration = dwell + 'ms';
            fill.classList.add('is-animating');
            seg.classList.add('is-active');
          } else {
            seg.classList.remove('is-complete');
            fill.style.width = '0%';
          }
        });
      }

      function scrollToSlide(index) {
        current = (index + slides.length) % slides.length;
        updateSegments();
        suppressSync = true;
        if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(slideIds[current], false);
        }
        window.setTimeout(function () {
          suppressSync = false;
        }, 50);
      }

      function startAutoplay(resume) {
        clearTimeout(autoplayTimer);
        if (!resume) {
          updateSegments();
        }
        if (isPaused) return;
        if (slides.length > 1) {
          var wait = resume ? Math.max(50, segmentDuration - (pausedAt - segmentStart)) : dwell;
          autoplayTimer = setTimeout(function () {
            scrollToSlide(current + 1);
            startAutoplay();
          }, wait);
        }
      }

      function goTo(index) {
        scrollToSlide(index);
        startAutoplay();
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      segments.forEach(function (seg, i) {
        seg.addEventListener('click', function () {
          goTo(i);
        });
      });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          isPaused = !isPaused;
          box.classList.toggle('is-paused', isPaused);
          pauseBtn.setAttribute('data-playing', isPaused ? 'false' : 'true');
          pauseBtn.innerHTML = isPaused ? '&#9654;' : '&#10073;&#10073;';
          pauseBtn.setAttribute('aria-label', isPaused ? 'Play gallery' : 'Pause gallery');
          if (isPaused) {
            pausedAt = Date.now();
            clearTimeout(autoplayTimer);
          } else {
            startAutoplay(true);
          }
        });
      }

      viewer.addEventListener('slideChanged', function (event) {
        if (suppressSync) return;
        var mediaId = event.detail && event.detail.currentElement && event.detail.currentElement.dataset.mediaId;
        if (!mediaId) return;
        var idx = slideIds.indexOf(mediaId);
        if (idx === -1 || idx === current) return;
        current = idx;
        clearTimeout(autoplayTimer);
        updateSegments();
        if (!isPaused) {
          autoplayTimer = setTimeout(function () {
            scrollToSlide(current + 1);
            startAutoplay();
          }, dwell);
        }
      });

      startAutoplay();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
